import { Directive, input } from '@angular/core';

@Directive({
  selector: '[scrollTo]',
  standalone: false,
  'host': {
    '(click)': 'scroll()'
  }
})
export class ScrollTo {
  readonly scrollTo=input.required<number>();

  constructor() { }

  scroll(){
    window.scrollTo({
      top: this.scrollTo(),
      behavior: 'smooth'
    });
  }

}
